<script setup>
import { ref } from 'vue'
import dayjs from 'dayjs'

import { getI18n } from '@/plugins/i18n'

import { snoozePresets } from '@/composables/notifications'

const emit = defineEmits(['snooze'])

const i18n = getI18n()

const presets = ref([])
const customUntil = ref(null)
const isCustom = ref(false)

const onBeforeShow = () => {
  presets.value = snoozePresets()
  isCustom.value = false
  customUntil.value = dayjs().add(1, 'day').format('YYYY-MM-DDTHH:mm')
}
</script>

<template>
  <q-menu
    anchor="bottom right"
    self="top right"
    @before-show="onBeforeShow"
  >
    <q-list
      dense
      style="min-width: 14rem;"
    >
      <q-item-label header>
        {{ i18n.t('common.snooze') }}
      </q-item-label>
      <q-item
        v-for="preset in presets"
        :key="preset.label"
        v-close-popup
        clickable
        @click="emit('snooze', preset.until())"
      >
        <q-item-section>{{ preset.label }}</q-item-section>
      </q-item>
      <q-item
        v-if="!isCustom"
        clickable
        @click="isCustom = true"
      >
        <q-item-section>{{ i18n.t('common.snoozeCustom') }}</q-item-section>
      </q-item>
      <q-item v-else>
        <q-item-section>
          <q-input
            v-model="customUntil"
            type="datetime-local"
            dense
            :label="i18n.t('common.until')"
          />
        </q-item-section>
        <q-item-section side>
          <q-btn
            v-close-popup
            flat
            round
            dense
            color="primary"
            icon="mdi-check"
            :disable="!customUntil || !dayjs(customUntil).isAfter(dayjs())"
            @click="emit('snooze', dayjs(customUntil))"
          />
        </q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>
